import React, {useState, useEffect} from "react";
import axios from "axios";

// Importing images
import logo from "../assets/img/logo.webp";
import BoucMediaWhite from "../assets/img/BoucMedia_White_3_1296x.webp";
import Layout from "./Label";

function ExampleReactComponent() {
    const [pageData, setPageData] = useState(null); // Для хранения данных страницы
    const [loading, setLoading] = useState(true); // Для отслеживания состояния загрузки

    useEffect(() => {
        // Запрос к REST API
        axios
            .get("/wp-json/wp/v2/pages/50")
            .then((response) => {
                setPageData(response.data); // Устанавливаем данные страницы
                setLoading(false); // Завершаем загрузку
            })
            .catch((error) => {
                console.error("Error fetching the page data:", error);
                setLoading(false);
            });
    }, []); // Пустой массив зависимостей означает, что запрос выполняется только один раз

    if (loading) {
        return <div>Loading...</div>; // Пока данные загружаются
    }

    if (!pageData) {
        return <div>Error loading page data</div>; // Если данные не были получены
    }

    return (
        <Layout>
            <section className="page">
                <div className="container ">
                    <div className="page-text page-text-mini">
                        <div className="section-header text-center">
                            <h1 style={{fontSize: "4rem"}}>{pageData.title.rendered}</h1>
                        </div>
                        <div
                            className="our-services-content"
                            dangerouslySetInnerHTML={{__html: pageData.content.rendered}}
                        ></div>
                    </div>
                </div>
            </section>
        </Layout>
    );
}

export default ExampleReactComponent;
